import { ClientModel, ProductModel } from "../../../Utils/Models";
import { formatDate, getFullName } from "../../../Utils/Utils";
import { Vocabulary } from "../../../Utils/Vocabulary";

/**
 * Generates an array of column objects for the clients instructor report.
 */
export const clientsInstructorColumns = [
  {
    name: "orderId",
    label: Vocabulary.id,
    options: {
      sort: false,
      display: false,
    },
  },
  {
    name: "orderNumber",
    label: Vocabulary.id,
  },
  {
    name: "client",
    label: Vocabulary.cursant,
    options: {
      sortField: "client.firstName",
      customBodyRender: (value: ClientModel) => {
        return getFullName(value);
      },
      exportValue: (value: ClientModel) => getFullName(value),
    },
  },
  {
    name: "product",
    label: Vocabulary.product,
    options: {
      sortField: "product.name",
      customBodyRender: (value: ProductModel) => {
        return value?.name;
      },
      exportValue: (value: ProductModel) => value?.name || "",
    },
  },
  {
    name: "createdAt",
    label: Vocabulary.createdAt,
    options: {
      customBodyRender: (value: Date) => {
        return formatDate(value, "dd.MM.yyyy HH:mm");
      },
      exportValue: (value: Date) => value ? formatDate(value, "dd.MM.yyyy HH:mm") : "",
    },
  },
];
